import { render, staticRenderFns } from "./salesCheques.vue?vue&type=template&id=983ec244&"
import script from "./salesCheques.vue?vue&type=script&lang=js&"
export * from "./salesCheques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports